import React from 'react'
import { List, Header } from 'semantic-ui-react'
import Countdown from "react-countdown-now"



const About = () => (
    <List divided relaxed ordered>
        <h2><font color='green'>About Phykraun</font></h2>
        <p><b>Phykraun</b> is <b>one of the largest</b> and <b>fastest growing startups in Zimbabwe</b>. <i>Products</i> from the company include, <b>Dystater cryptocurrency</b>, <b>Bazaar cryptocurrency exchange</b>, <b>CodeDialer</b> and <b>QuickSave marketplace</b>. You can <i>visit our site</i> to get these, plus more <i>apps / software</i>. Check us out on <i>social media</i> too.</p>


        <h3>More about <i> <font color="green">Phykraun</font></i>:</h3>

        <List.Item>
            <i>Location</i>: <b>Zimbabwe, Harare / Masvingo</b>
        </List.Item>

        <List.Item>
            <i>Number of employees</i>: <b>1 permanent, but 3 at times</b>
        </List.Item>

        <List.Item>
            <i>CEO and Founder</i>: <b>Stanley Makazhe</b>
        </List.Item>

        <List.Item>
            <i>Notable Awards</i>: <b>One</b>
        </List.Item>

    </List>
)

export default About
